import { Box, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

import useAppState from '../hooks/useAppState';

export const OFFLINE_BANNER_HEIGHT = 32;

/**
 * Bandeau hors-ligne. Rendu DANS l'AppBar, juste au-dessus du Toolbar/Breadcrumb,
 * en dessous de la safe-area-inset-top (les notifications OS restent intactes).
 *
 * NB : on n'écoute pas `online`/`offline` pour déclencher de reconnect ici —
 * c'est juste un indicateur visuel. La reconnexion socket est gérée par le
 * useEffect[isAppActive] de SocketEvents (foreground return), qui couvre déjà
 * le cas du retour réseau quand l'app revient au premier plan.
 */
const OfflineBanner = () => {
  const { isOnline } = useAppState();

  if (isOnline) return null;

  return (
    <Box
      sx={{
        height: OFFLINE_BANNER_HEIGHT,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        px: 2
      }}
    >
      <WifiOffIcon fontSize="small" />
      <Typography variant="body2" fontWeight="bold">
        Vous êtes en mode hors ligne.
      </Typography>
    </Box>
  );
};

export default OfflineBanner;
